/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { DeletePlanCommand } from '../../models/delete-plan-command';

export interface ApiPlanDeletePlanDelete$Plain$Params {
  
    /**
     * Plan deletion command
     */
    body?: DeletePlanCommand
}

export function apiPlanDeletePlanDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanDeletePlanDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanDeletePlanDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanDeletePlanDelete$Plain.PATH = '/api/Plan/DeletePlan';
